import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-price",
  "use": "icon-price-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-price\"><path d=\"M806.4 621.9h-274V402.4h274c11.6 0 21.1-8.9 21.1-20 0-11-9.4-19.9-21.1-19.9h-274c0-3.4-0.9-6.5-2.4-9.3L800.1 97.5c8.4-7.9 8.4-20.8 0-28.8-8.4-7.9-22-7.9-30.4 0L511.3 313.3 252.9 68.7c-8.4-7.9-22-7.9-30.4 0-8.4 7.9-8.4 20.8 0 28.8l270.1 255.7c-1.6 2.8-2.4 5.9-2.4 9.3h-274c-11.6 0-21.1 8.9-21.1 19.9 0 11 9.4 20 21.1 20h274v219.5h-274c-11.6 0-21.1 8.9-21.1 19.9 0 11 9.4 19.9 21.1 19.9h274v259.4c0 11 9.4 19.9 21.1 19.9 11.6 0 21.1-8.9 21.1-19.9V661.8h274c11.6 0 21.1-8.9 21.1-19.9 0-11.1-9.4-20-21.1-20z\" p-id=\"3564\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/price.svg
// module id = Y2tI
// module chunks = 132